import React, {FC} from 'react';

import {ExplanationInformationCard} from 'components/ais/explanation-information-card';
import {Table} from 'components/table';
import {ITableScroll} from 'components/table/table';
import {EEntityType} from 'shared/constants/entities';

export interface IAisExplanationInformationPageProps {
    url: string;
    hideTitle?: boolean;
    entityType?: EEntityType;
    entityName: string;
    scroll?: ITableScroll;
    entity: string | null;

}

export const AisExplanationInformationPage: FC<IAisExplanationInformationPageProps> = ({
    entity: id,
    scroll,
    url,
    hideTitle,
    entityType,
    entityName,
}: IAisExplanationInformationPageProps) => (
    <>
        <Table
            hideTitle={hideTitle}
            entityName={entityName}
            url={url}
            entityType={entityType}
            scroll={scroll}
            defaultSortQuery={{
                sorterField: 'downloadDate',
                sorterOrder: 'descend',
            }}
        />
        {id && (
            <ExplanationInformationCard
                id={id}
            />
        )}
    </>
);
